"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("BasisModal", {
    attrs: {
      size: "large",
      title: "从科目库添加科目"
    },
    on: {
      ok: _vm.handleOk
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c("CostItemTableTree", _vm._b({
    staticStyle: {
      height: "calc(70vh - 100px)"
    },
    attrs: {
      selectable: true
    },
    on: {
      change: _vm.handleChange
    }
  }, "CostItemTableTree", _vm.$props, false))], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;